import { useEffect } from 'react';

import { LogoType } from 'coreOld/enums';

import { useGetLogoPaths } from './configs';

export const useFavIcon = () => {
  const { logoPaths } = useGetLogoPaths();

  useEffect(() => {
    const favIcon = document.getElementById('favIcon') as HTMLLinkElement;

    if (favIcon) {
      favIcon.href = logoPaths?.[LogoType.FAVICON];
    }
  }, [logoPaths?.[LogoType.FAVICON]]);
};
